import React, { useEffect, useState } from "react";
import CallToAction from "../partials/cta";
import CircularProgress from "@mui/material/CircularProgress";
import FieldLabel from "../../../components/label";
import SectionTitle from "../../../components/sectionTitle";
import { useStyles } from "../indexFormStyles";
import { Alert, Box } from "@mui/material";
import { buildLeadPageUrl, getStorageItem } from "../../../helpers/utils";
import { postWebService } from "../../../helpers/server";
import { buildTerminateJourneyPayload } from "../../../helpers/customer";
import { useHistory } from "react-router";
import { withStyles } from "@mui/styles";
import HealthVitalsReport from "./healthVitalsReport";

function BuyflowApplicationTerminated({
  classes: { containerButton, formGroup, loaderBox, main },
}) {
  const history = useHistory();
  const [isLoaded, setIsLoaded] = useState(true);
  const [healthVitals, setHealthVitals] = useState([]);

  useEffect(() => {
    const stored = getStorageItem("healthVitals");
    console.log(typeof stored);
    if (stored) {
      // Replace convertToArrayOfObjects with your actual conversion function if needed
      setHealthVitals(convertToArrayOfObjects(JSON.parse(stored)));
    }

    async function terminateJourney() {
      try {
        const response = await postWebService(
          "update-order.php",
          buildTerminateJourneyPayload()
        );
      } catch (error) {
        // console.log(error);
      }
    }

    terminateJourney();
  }, []);

  const convertToArrayOfObjects = (object = {}) => {
    if (object === null || object === "null" || object === undefined) {
      return [];
    }

    const array = Object.entries(object).map(([slug, values]) => ({
      ...values,
      slug,
    }));

    return array;
  };

  const handleClick = () => (window.location.href = buildLeadPageUrl());

  return isLoaded ? (
    <Box
      className={main}
      sx={{ padding: "4px", height: "700px", overflowY: "scroll" }}
    >
      <Box container={"true"} justifyContent="center" mt={2}>
        <SectionTitle title={"Journey Terminated"} />
        <Box textAlign={"left"}>
          <Box className={formGroup}>
            <FieldLabel variant={"subtitle1"} label="Reason for Termination" />
          </Box>
          <Box className={formGroup}>
            <Alert color="warning" icon={false}>
              {getStorageItem("journeyCloseReason")}
            </Alert>
          </Box>

          {healthVitals.length > 0 && (
            <HealthVitalsReport healthVitals={healthVitals} />
          )}
        </Box>

        <Box
          className={containerButton}
          justifyContent="center"
          alignContent="center"
        >
          <CallToAction
            buttonType={"submit"}
            text={"Re-initiate Journey"}
            handleClick={handleClick}
          />
        </Box>
      </Box>
    </Box>
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  BuyflowApplicationTerminated
);
